var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tooltip-mobile-content',{attrs:{"text":_vm.$translate('components.swapSettingsCard.deadline.tooltip'),"show":_vm.show,"container-class":"w-full bg-lavender-pinocchio text-lg text-black font-semibold p-4 rounded-lg text-center mt-2"}})}
var staticRenderFns = []

export { render, staticRenderFns }